import script from "./ProductControls.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductControls.vue?vue&type=script&setup=true&lang=js"

import "./ProductControls.vue?vue&type=style&index=0&id=0b5f55aa&scoped=true&lang=css"

import exportComponent from "/Users/darrenlumber/Sites/office-drop-craft/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b5f55aa"]])

export default __exports__